<template>
  <div class="bg-gradient-lighter min-vh-100">
    <!-- Header -->
    <div class="header bg-gradient-orange py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Gain Access to ChinesePod Affiliate Program
              </h1>
              <p class="text-lead text-white">
                Earn affiliate commissions while learning Chinese with
                ChinesePod! Join the Affiliate Program and get started!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--9 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="card bg-secondary border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <validation-observer
                v-if="!success"
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit="handleSubmit(register)">
                  <base-input
                    class="mb-3"
                    label="Name"
                    prepend-icon="fas fa-user"
                    placeholder="John Smith"
                    name="name"
                    rules="required"
                    v-model="model.name"
                  >
                  </base-input>
                  <base-input
                    class="mb-3"
                    wrapperClasses="mb-0"
                    label="Affiliate Tag"
                    prepend-icon="fas fa-tags"
                    placeholder="Your-Unique-Identifier"
                    name="affiliate tag"
                    :rules="{ required: true, alpha_dash: true, min: 8 }"
                    v-model="model.tag"
                  >
                  </base-input>

                  <base-input
                    class="mb-3"
                    wrapperClasses="mb-0"
                    label="Your location"
                    prepend-icon="fas fa-map-marker-alt"
                    placeholder=" New York, USA"
                    name="your location"
                    :rules="{ required: true }"
                    v-model="model.location"
                  >
                  </base-input>

                  <base-input
                    type="number"
                    class="mb-3"
                    wrapperClasses="mb-0"
                    label="Audience size"
                    prepend-icon="fas fa-users"
                    placeholder="10000"
                    name="audience size"
                    :rules="{ required: true, min: 1 }"
                    v-model="model.audienceSize"
                  >
                  </base-input>

                  <base-input
                    type="textarea"
                    class="mb-3"
                    wrapperClasses="mb-0"
                    label="Main countries reached"
                    prepend-icon="fas fa-globe"
                    placeholder="USA, Canada"
                    name="main countries reached"
                    :rules="{ required: true }"
                    v-model="model.mainMarkets"
                    :canResize="false"
                  >
                  </base-input>

                  <br />
                  <small
                    >Enter your details, tell us about your location, audience
                    reach, and use the generated affiliate tag or enter your
                    own.</small
                  >

                  <div v-if="error" class="pt-2">
                    <div class="alert alert-danger">
                      {{ error }}
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col-12 text-center">
                      <base-button
                        :loading="loading"
                        type="primary"
                        size="lg"
                        @click="handleSubmit(register)"
                      >
                        Register
                      </base-button>
                    </div>
                  </div>
                </form>
              </validation-observer>
              <div v-if="success">
                <div class="alert alert-success">
                  Thank you for signing up! You will be redirected shortly.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'

import randomToken from 'random-token'

import { mapActions, mapGetters } from 'vuex'

export default {
  title() {
    return `${this.$route.name} | ChinesePod SchoolZone`
  },
  name: 'register',
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      success: false,
      error: '',
      loading: false,
      model: {
        name: '',
        tag: '',
        location: '',
        audienceSize: '',
        mainMarkets: ''
      }
    }
  },
  beforeMount() {
    this.model = Object.assign({}, this.userInfo)
    if (!this.model.location) {
      this.model.location = ''
    }
    this.model.tag = randomToken(8).toUpperCase()
  },
  methods: {
    ...mapActions('affiliates', ['getAffiliateInfo']),
    async register() {
      this.error = ''
      this.loading = true
      await this.axios
        .post(
          process.env.VUE_APP_ROOT_API + '/api/v1/affiliates/register',
          this.model
        )
        .then(async (_) => {
          this.success = true
          await this.getAffiliateInfo().catch(() => {})
          this.$router.push({ name: 'Register Success' })
        })
        .catch((err) => {
          const { response } = err

          const { data } = response

          this.error =
            (data && data.error) ||
            'Sorry! Something went wrong, please try again!'
        })
      this.loading = false
    }
  },
  mounted() {}
}
</script>
<style></style>
